import type { NestedKeys } from '../../types.ts';

/**
 * `en` · `chat` namespace — the companion conversation stream: composer,
 * message states, and the GF switcher.
 */
export const chat = {
  composer: {
    placeholder: 'Message {companionName}…',
    send: 'Send',
    /** Ends the run server-side — the turn is discarded and never billed. */
    stop: 'Stop',
    typing: '{companionName} is typing…',
  },
  message: {
    sending: 'Sending…',
    failed: 'Failed to send. Tap to retry.',
    retry: 'Retry',
    edited: 'Edited',
  },
  switcher: {
    title: 'Your companions',
    addNew: 'Build a new companion',
    empty: 'You have not built a companion yet.',
  },
  quota: {
    banner: 'You have {remaining} messages left today.',
    exhausted: 'Out of free messages. Upgrade to keep chatting.',
  },
  paywall: {
    upgrade: 'Upgrade',
    topUp: 'Buy credits',
    dailyCap: {
      title: "You've hit today's free limit",
      body: 'Upgrade to keep chatting now, or come back tomorrow for more free messages.',
    },
    credits: {
      title: 'Out of credits',
      body: 'Top up or upgrade to generate photos and videos and keep the conversation going.',
    },
  },
  proactive: {
    newMessage: '{companionName} sent you a message',
  },
} as const;

export type ChatMessages = typeof chat;

/** Typo-safe dot-path keys for the `chat` namespace. */
export type ChatKey = NestedKeys<ChatMessages>;
